import React, { FC } from 'react';
import {
    default as Picker,
    ReactDatePickerProps,
    registerLocale,
} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import pt from 'date-fns/locale/pt-BR';
import { Input } from '../input';
import { InputProps } from '../input/props';

registerLocale('pt', pt);

const CustomInput = ({
    value,
    onClick,
    label,
    name,
    isValid,
    ...rest
}: InputProps) => (
    <Input
        {...rest}
        value={value}
        label={label}
        name={name}
        isValid={isValid}
        onClick={onClick}
    />
);

export const InputDatePicker: FC<
    InputProps & Partial<ReactDatePickerProps> & any
> = ({ onChange, value, ...rest }) => {
    return (
        <Picker
            customInput={<CustomInput value={value} {...rest} />}
            dateFormat='dd/MM/yyyy'
            selected={value}
            showYearDropdown={true}
            showMonthDropdown={true}
            locale='pt'
            onChange={(date: any) => onChange?.(date)}
        />
    );
};
